import styled from "styled-components";
import { fadeIn, slideInFromLeft, slideInFromRight, fadeInAnimation } from "../../styles/Animations";

const getBackground = (brand, category) => {
  const backgrounds = {
    'dr-reckeweg': {
      'goteros': 'linear-gradient(180deg, #7C0100 20%, #E20200 100%)',
      'procaina-kholer': 'linear-gradient(180deg, #282C34 20%, #1E384F 100%)',
      'sales': 'linear-gradient(180deg, #242424 20%, #4D4D4D 100%)',
      default: 'linear-gradient(180deg, #7C0100 20%, #E20200 100%)',
    },
    'tegor': {
      default: 'linear-gradient(180deg, rgb(203, 166, 43) 20%, #F5CA41 100%)'
    },
    'helixor': {
      'helixor-a': 'linear-gradient(180deg, #DEA101 20%,rgb(255, 184, 5) 100%)',
      'helixor-m': 'linear-gradient(180deg, #ED7421 20%,#D66415 100%)',
      'helixor-p': 'linear-gradient(180deg, #D30023 20%,#DA0024 100%)',
       default: 'linear-gradient(180deg,rgb(78, 1, 1) 20%, #D71B20 100%)'
    },
    'symbio-pharm': {
      'symbioflor-1': 'linear-gradient(180deg, #7C0100 20%, #D71B20 100%)',
      'symbioflor-2': 'linear-gradient(180deg, #149BD7 10%,rgb(167, 226, 252) 100%)',
      'symbiolact-comp': 'linear-gradient(180deg, #4E366E 10%,rgb(159, 108, 224) 100%)',
      'symbiointest': 'linear-gradient(180deg, #99B349 10%,rgb(205, 241, 98) 100%)',
      default: 'linear-gradient(180deg,rgb(174, 1, 1) 20%, #D71B20 100%)'
    },
    'regenhial': {
      default: 'linear-gradient(180deg, #848383 20%, #9C9C9C 100%)'
    },
    default: 'linear-gradient(180deg, #282C34 20%, #000001 100%)'
  };

  const brandBackgrounds = backgrounds[brand] || backgrounds.default;
  return category ? (brandBackgrounds[category] || brandBackgrounds.default) : brandBackgrounds.default;
};

const getColor = (brand, category) => {
  const backgrounds = {
    'dr-reckeweg': {
      'goteros': '#E20200',
      'procaina-kholer': '#1E384F',
      'sales': '#4D4D4D',
      default: '#E20200',
    },
    'tegor': {
      default: '#F5CA41'
    },
    'helixor': {
      'helixor-a': 'rgb(255, 184, 5)',
      'helixor-m': '#D66415',
      'helixor-p': '#DA0024',
       default: '#D71B20'
    },
    'symbio-pharm': {
      'symbioflor-1': '#D71B20',
      'symbioflor-2': 'rgb(167, 226, 252)',
      'symbiolact-comp': 'rgb(159, 108, 224) ',
      'symbiointest': 'rgb(205, 241, 98)',
      default: '#D71B20'
    },
    'regenhial': {
      default: '#9C9C9C'
    },
    default: '#000001'
  };

  const brandBackgrounds = backgrounds[brand] || backgrounds.default;
  return category ? (brandBackgrounds[category] || brandBackgrounds.default) : brandBackgrounds.default;
};


export const Content = styled.div`
  width: 100%;
  background: white;
  display: flex;

  @media (max-width: 550px) {
    /* Phones */
    flex-direction: column;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    flex-direction: column;
  }
`;

export const ProductImage = styled.div`
  width: 55%;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  position: relative;

  img{
    animation: ${slideInFromLeft} 0.5s ease-in-out;
  }
  

  @media (max-width: 550px) {
    /* Phones */
    width: 100%;
    height: 50vh;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 100%;
    height: 40vh;
  }
`;

export const ProductInfo = styled.div`
  width: 45%;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 40px;
  color: #06081B;
 

  @media (max-width: 550px) {
    /* Phones */
    width: 90%;
    margin-left: 0px;
    padding: 20px 20px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 90%;
    margin-left: 0px;
    padding: 20px 20px;
  }
`;

export const ProductImageSectionColor = styled.div`
  background: ${props => getBackground(props.brand, props.category)};
  height: 50%;
`;

export const ProductImageSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  background-color: rgba(242, 242, 242, 1);
  position: relative;

  img {
    position: absolute;
    top: 40%;
    width: 80%;
    z-index: 1;

    @media (max-width: 1100px) {
      /* Tablets */
      width: 35%;
      top: -10px;
    }

    @media (max-width: 550px) {
      /* Phones */
      width: 60%;
      top: 0;
    }
  }
`;

export const Title = styled.h1`
  margin-top: 40px;
  color: #06081B;
  animation: ${slideInFromRight} 0.5s ease-in-out;
 

  @media (max-width: 1100px) {
    /* Tablets */
    width: 90%;
    margin-left: 0px;
    padding: 20px 20px;
  }

  @media (max-width: 550px) {
    /* Phones */
    width: 90%;
    margin-left: 0px;
    padding: 20px 20px;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: rgba(125, 124, 124, 1);

  @media (max-width: 1100px) {
    /* Tablets */
    width: 90%;
    margin-left: 0px;
    padding: 0px 20px;
  }

  @media (max-width: 550px) {
    /* Phones */
    width: 90%;
    margin-left: 0px;
    padding: 0px 20px;
  }
`;

export const Button = styled.button`
  align-self: flex-end;
  background-color: rgba(40, 44, 52, 1);
  color: rgb(255, 255, 255);
  border: 1px solid rgba(40, 44, 52, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    border: 1px solid rgba(234, 11, 42, 1);
    color: white;
  }
`;

export const Options = styled.div`
  display: flex;

  @media (max-width: 1100px) {
    /* Tablets */
    width: 90%;
    margin-left: 0px;
    padding: 0px 20px;
  }

  @media (max-width: 550px) {
    /* Phones */
    width: 90%;
    margin-left: 0px;
    padding: 0px 20px;
  }

  p {
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 400;
    cursor: pointer;
    position: relative;
    padding-bottom: 5px;

    &:hover {
      text-decoration: underline;
    }

    &.selected {
      text-decoration: underline;
      text-underline-offset: 5px;
      font-weight: 600;
      color: ${props => getColor(props.brand, props.category)};
    }
  }
`;

export const DescriptionProduct = styled.div`
  width: 80%;
  margin-top: 20px;

  height: 70%;
  overflow-y: auto;
  animation: ${fadeInAnimation} 0.3s ease-in-out;

  @media (max-width: 1100px) {
    /* Tablets */
    width: 90%;
    margin-left: 0px;
    padding: 0px 20px 20px 20px;
  }

  @media (max-width: 550px) {
    /* Phones */
    width: 90%;
    margin-left: 0px;
    padding: 0px 20px 20px 20px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;

  @media (max-width: 1100px) {
    /* Tablets */
    padding: 10px 20px;
  }

  @media (max-width: 550px) {
    /* Phones */
    padding: 10px 20px;
  }
`;

export const ButtonRight = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-top: 2px solid #000000;
  color: #06081B;
  padding-top: 5px;

  &:hover {
    cursor: pointer;
    color: #e30016;
  }

  @media (max-width: 1100px) {
    /* Tablets */
  }

  @media (max-width: 550px) {
    /* Phones */
  }
`;

export const ButtonLeft = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  width: 100%;
 
  margin-top: 5px;
  padding-bottom: 5px;
  color: #06081B;


  &:hover {
    cursor: pointer;
    color: #e30016;
  }
`;

export const MoreButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ContentContainer = styled.div`
  width: 100%;
`;
